import React from "react";

const ChevronRightIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.9701 14.9713C13.6654 15.2674 13.1924 15.2837 12.8692 15.0249L12.7917 14.9545L8.04402 10.0689L12.8088 5.44249C13.139 5.12188 13.6666 5.12966 13.9872 5.45985C14.2831 5.76465 14.2993 6.23763 14.0403 6.56076L13.9698 6.63823L10.4018 10.1037L13.9869 13.7929C14.283 14.0976 14.2994 14.5706 14.0405 14.8938L13.9701 14.9713Z" fill="#212121" />
        </svg>
    );
};

export default ChevronRightIcon;
